import { connect } from 'react-redux';
import App from './App';
import { tryResetApp } from '../actions';
import { goRouting, LOCATION } from '../routesMap';

const mapStateToProps = state => {
  return {
    navigation: state.navigation,
    currentPath: state.location.pathname,
    location_id: state.location.payload.location_id ? state.location.payload.location_id.toString() : '',
    loading: state.loading
  };
}

const mapDispatchToProps = dispatch => ({
  resetApp: () => dispatch(tryResetApp()),
  goHome: () => dispatch(goRouting(LOCATION))
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
